function SolText({children, className}) {
	return (<span className={className || "st"}>{children}</span>);
}

export default SolText;